var StepTwoInbentaBaseView, StepTwoInbentaNonNLPView, SupportAPIHelper, SupportErrorHelper, SupportMainContentWrapperView,
  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SupportMainContentWrapperView = require('../../main_content_view');

StepTwoInbentaBaseView = require('./base_view');

SupportAPIHelper = require('../../../helpers/API');

SupportErrorHelper = require('../../../helpers/error');

StepTwoInbentaNonNLPView = (function(superClass) {
  extend(StepTwoInbentaNonNLPView, superClass);

  function StepTwoInbentaNonNLPView() {
    this.callTimeoutFn = bind(this.callTimeoutFn, this);
    this.callInbentaEventCb = bind(this.callInbentaEventCb, this);
    this.helpContentError = bind(this.helpContentError, this);
    this.helpContentSuccess = bind(this.helpContentSuccess, this);
    this.enableTicketDirectionButton = bind(this.enableTicketDirectionButton, this);
    this.enableResolvedButton = bind(this.enableResolvedButton, this);
    return StepTwoInbentaNonNLPView.__super__.constructor.apply(this, arguments);
  }

  StepTwoInbentaNonNLPView.prototype.initialize = function() {
    return StepTwoInbentaBaseView.prototype.initialize.apply(this, arguments);
  };

  StepTwoInbentaNonNLPView.prototype.renderInbentaSearchBox = function(contentWrapper) {};

  StepTwoInbentaNonNLPView.prototype.fetchAndRenderCategory = function(contentWrapper) {
    if (this.dropDownModel.has('categories')) {
      return this.renderCategory(contentWrapper);
    } else {
      this.spinnerView.show({
        container: contentWrapper,
        append: true,
        height: '50px'
      });
      startTimer("t_dc");
      return $.when(this.dropDownModel.fetch(), this.dropDownCombinationsModel.fetch()).done((function(_this) {
        return function(model, response, options) {
          var ref;
          stopTimer("t_dc");
          _this.flexStepThree.dropdownCombinations = (ref = response.flexStepThree) != null ? ref['dropdownCombinations'] : void 0;
          _this.spinnerView.remove();
          return _this.handleDropdownsCb(contentWrapper);
        };
      })(this)).fail((function(_this) {
        return function() {
          _this.spinnerView.remove();
          return _this.handleAjaxErrors();
        };
      })(this));
    }
  };

  StepTwoInbentaNonNLPView.prototype.handleDropdownsCb = function(contentWrapper) {
    return this.renderCategory(contentWrapper);
  };

  StepTwoInbentaNonNLPView.prototype.renderCategory = function(contentWrapper) {
    var categoryArray, contentCategory, isFilterDropdowns;
    isFilterDropdowns = window.evaluate(typeof experiments !== "undefined" && experiments !== null ? experiments.filterDropdowns : void 0) ? true : false;
    categoryArray = this.getCategoryList();
    contentWrapper.append(toHtml(this.categoryTemplate, {
      categories: categoryArray,
      isFilterDropdowns: isFilterDropdowns
    }, this.I18nScope));
    contentCategory = Groupon.Support.ContentModel.getCategory();
    if (contentCategory && contentCategory !== null) {
      $(".category", contentWrapper).val(contentCategory.id);
      $(".category option[value='" + contentCategory.id + "']", contentWrapper).attr("selected", "selected");
      return this.renderSubCategory(contentWrapper);
    }
  };

  StepTwoInbentaNonNLPView.prototype.renderSubCategory = function(contentWrapper) {
    var contentSubCategory, subdropdwn;
    this.disableAllButton();
    subdropdwn = $('.sub-dropdown', contentWrapper);
    subdropdwn.html("");
    subdropdwn.html(toHtml(this.subCategoryTemplate, {
      subCategories: this.getSubCategoryList()
    }, this.I18nScope));
    contentSubCategory = Groupon.Support.ContentModel.getSubCategory();
    if (contentSubCategory && contentSubCategory !== null) {
      $(".sub-category", contentWrapper).val(contentSubCategory.id);
      $(".sub-category option[value='" + contentSubCategory.id + "']", contentWrapper).attr("selected", "selected");
      return this.fetchHelpContent(contentWrapper);
    }
  };

  StepTwoInbentaNonNLPView.prototype.enableResolvedButton = function(event) {
    var ref, ref1;
    if (((ref = this.flexStepThree) != null ? ref['allowed'] : void 0) && !((ref1 = this.flexStepThree) != null ? ref1['responseReceived'] : void 0)) {
      return this.inbentaEventType = event.type;
    }
    this.isInbentaContentShown = true;
    this.sendTrackyCallForHelpContentBeingShown(true);
    this.$('.issue-check').show();
    return this.$('.direct-ticket').hide();
  };

  StepTwoInbentaNonNLPView.prototype.disableAllButton = function() {
    this.isInbentaContentShown = false;
    return StepTwoInbentaBaseView.prototype.disableAllButton.apply(this, arguments);
  };

  StepTwoInbentaNonNLPView.prototype.enableTicketDirectionButton = function(event) {
    var ref, ref1;
    if (((ref = this.flexStepThree) != null ? ref['allowed'] : void 0) && !((ref1 = this.flexStepThree) != null ? ref1['responseReceived'] : void 0)) {
      return this.inbentaEventType = event.type;
    }
    this.isInbentaContentShown = true;
    this.sendTrackyCallForHelpContentBeingShown(false);
    this.$('.issue-check').hide();
    return this.$('.direct-ticket').show();
  };

  StepTwoInbentaNonNLPView.prototype.setCategoryToWindow = function() {
    var category;
    this.contentRequests = abortAjaxRequests(this.contentRequests);
    this.disableAllButton();
    if (this.inbentaTimeoutFn != null) {
      clearTimeout(this.inbentaTimeoutFn);
    }
    if (this.inbentaContentLoadTimeoutFn != null) {
      clearTimeout(this.inbentaContentLoadTimeoutFn);
    }
    category = this.$('.category option:selected').val();
    addToTrackingHub(category, null);
    this.clearElement('.inbenta-content');
    if (category === '') {
      this.$(".sub-category option[value='']").attr("selected", "selected");
      this.$('.sub-category').trigger('change');
      Groupon.Support.ContentModel.setCategory(null);
      Groupon.Support.ContentModel.setSubCategory(null);
      return this.clearElement('.sub-dropdown');
    } else {
      Groupon.Support.ContentModel.setCategory({
        id: this.$('.category option:selected').val(),
        text: this.$('.category option:selected').text()
      });
      Groupon.Support.ContentModel.setSubCategory(null);
      return this.renderSubCategory(this.$el);
    }
  };

  StepTwoInbentaNonNLPView.prototype.setSubCategoryToWindow = function() {
    var subcategory;
    this.contentRequests = abortAjaxRequests(this.contentRequests);
    subcategory = this.$('.sub-category option:selected').val();
    if (this.inbentaTimeoutFn != null) {
      clearTimeout(this.inbentaTimeoutFn);
    }
    if (this.inbentaContentLoadTimeoutFn != null) {
      clearTimeout(this.inbentaContentLoadTimeoutFn);
    }
    this.disableAllButton();
    addToTrackingHub(Groupon.Support.ContentModel.getCategory().id, subcategory);
    if (subcategory === '') {
      Groupon.Support.ContentModel.setSubCategory(null);
      return this.clearElement('.inbenta-content');
    } else {
      Groupon.Support.ContentModel.setSubCategory({
        id: this.$('.sub-category option:selected').val(),
        text: this.$('.sub-category option:selected').text()
      });
      return this.fetchHelpContent();
    }
  };

  StepTwoInbentaNonNLPView.prototype.fetchHelpContent = function(contentWrapper) {
    var data, urls;
    if (this.isFlexStepThreeAllowed()) {
      this.resetFlexStepThree();
      if (contentWrapper != null) {
        this.spinnerView.show({
          container: $('.inbenta-content', contentWrapper),
          height: '50px'
        });
      } else {
        this.spinnerView.show({
          container: $('.inbenta-content', this.$el),
          height: '50px'
        });
      }
      urls = this.getHelpContentPaths();
      data = this.getTaglines();
      this.contentRequests = SupportAPIHelper.parallel(urls, data, this.getHelpContentSuccessCb(), this.getHelpContenteErrorCb(), false, "t_ic", 60000);
    } else {
      Groupon.Support.ContentModel.flexibleStepThree = null;
      this.callTimeoutFn();
    }
    return this.setFlexibleContactChannels();
  };

  StepTwoInbentaNonNLPView.prototype.helpContentSuccess = function(results) {
    if (((results != null ? results.length : void 0) != null) > 0) {
      Groupon.Support.ContentModel.flexibleStepThree = results[0];
    }
    this.flexStepThree['responseReceived'] = true;
    if (!this.inbentaEventType) {
      return this.helpContentError();
    }
    return this.callInbentaEventCb();
  };

  StepTwoInbentaNonNLPView.prototype.helpContentError = function() {
    this.flexStepThree['responseReceived'] = true;
    if (this.inbentaEventType != null) {
      return this.callInbentaEventCb();
    }
    return this.callTimeoutFn();
  };

  StepTwoInbentaNonNLPView.prototype.callInbentaEventCb = function() {
    if (this.inbentaEventType === "help-text") {
      return this.enableResolvedButton();
    } else {
      return this.enableTicketDirectionButton();
    }
  };

  StepTwoInbentaNonNLPView.prototype.callTimeoutFn = function() {
    var timeoutFn;
    timeoutFn = (function(_this) {
      return function() {
        if (_this.isInbentaContentShown === false && _this.isCategoryAndSubcategorySelected()) {
          _this.helpContentLoadError();
          _this.enableTicketDirectionButton();
          _this.sendTrackyCallForHelpContentBeingShown(false);
          throw new Error(SupportErrorHelper.constructInbentaLoadErrorMessage());
        }
      };
    })(this);
    if (this.shouldHandleCbFromEmailForm()) {
      return;
    }
    if (this.inbentaContentLoadTimeoutFn != null) {
      clearTimeout(this.inbentaContentLoadTimeoutFn);
    }
    return this.inbentaTimeoutFn = setTimeout(timeoutFn, 5000);
  };

  StepTwoInbentaNonNLPView.prototype.shouldHandleCbFromEmailForm = function() {
    if ($('.inbenta-content').text().length <= 1) {
      if (!this.alreadySubCategoryChangeInitiated) {
        this.alreadySubCategoryChangeInitiated = true;
        this.$('.sub-category').trigger('change');
        this.inbentaContentLoadTimeoutFn = setTimeout(this.callTimeoutFn, 3000);
        return true;
      }
    }
  };

  return StepTwoInbentaNonNLPView;

})(StepTwoInbentaBaseView);

module.exports = StepTwoInbentaNonNLPView;

//# sourceMappingURL=data:application/json;base64,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
